var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScatterplotChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "72426C79-DAAE-4410-A031-BAF8E2F14718") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.06044489,19.9721357 C3.08310844,19.9721357 3.91602693,20.8068887 3.91602693,21.8298178 C3.91602693,22.852747 3.08310844,23.6875 2.06044489,23.6875 C1.03778133,23.6875 0.20486284,22.852747 0.20486284,21.8298178 C0.20486284,20.8068887 1.03778133,19.9721357 2.06044489,19.9721357 Z M11.8603768,10.6079192 C13.2928184,10.6079192 14.4589043,11.7753249 14.4589043,13.2084959 C14.4589043,14.6434506 13.2928184,15.8108562 11.8603768,15.8108562 C10.4279351,15.8108562 9.26184924,14.6434506 9.26184924,13.2084959 C9.26184924,11.7753249 10.4279351,10.6079192 11.8603768,10.6079192 Z M6.44061624,0.647960254 C7.7519061,0.647960254 8.81643828,1.7145891 8.81643828,3.02647123 C8.81643828,4.33924519 7.75012445,5.4049822 6.44061624,5.4049822 C5.13110803,5.4049822 4.06479419,4.33924519 4.06479419,3.02647123 C4.06479419,1.7145891 5.12932638,0.647960254 6.44061624,0.647960254 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.821233,20.9589 C4.37749889,20.9589 5.642466,22.2252988 5.642466,23.7824342 C5.642466,25.3395697 4.37660806,26.6068603 2.821233,26.6068603 C1.26496712,26.6068603 -1.77191595e-13,25.3395697 -1.77191595e-13,23.7824342 C-1.77191595e-13,22.2252988 1.26496712,20.9589 2.821233,20.9589 Z M11.2092121,13.3783439 C14.0331176,13.3783439 16.3314382,15.6783738 16.3314382,18.5063672 C16.3314382,21.3343605 14.0331176,23.6343904 11.2092121,23.6343904 C8.38530668,23.6343904 6.08698614,21.3334687 6.08698614,18.5063672 C6.08698614,15.6792656 8.38530668,13.3783439 11.2092121,13.3783439 Z M29.1744177,12.9324288 C31.0148558,12.9324288 32.5149999,14.4324871 32.5149999,16.2767918 C32.5149999,18.1193129 31.0148558,19.6211548 29.1744177,19.6211548 C27.3339796,19.6211548 25.8338355,18.1193129 25.8338355,16.2767918 C25.8338355,14.4342708 27.3339796,12.9324288 29.1744177,12.9324288 Z M22.6420206,8.84338763 C24.3203291,8.84338763 25.6859591,10.2105632 25.6859591,11.8907712 C25.6859591,13.5709792 24.3203291,14.9381548 22.6420206,14.9381548 C20.9637121,14.9381548 19.5980821,13.5709792 19.5980821,11.8907712 C19.5980821,10.2105632 20.9637121,8.84338763 22.6420206,8.84338763 Z M30.9560615,6.24191913 C32.63437,6.24191913 34,7.60909472 34,9.2893027 C34,10.9695107 32.63437,12.3366863 30.9560615,12.3366863 C29.277753,12.3366863 27.9130139,10.9695107 27.9130139,9.2893027 C27.9130139,7.60909472 29.277753,6.24191913 30.9560615,6.24191913 Z M23.1613698,-5.32907052e-15 C25.1265229,-5.32907052e-15 26.7246574,1.59994326 26.7246574,3.56732055 C26.7246574,5.53469783 25.1265229,7.13464109 23.1613698,7.13464109 C21.1962166,7.13464109 19.5980821,5.53469783 19.5980821,3.56732055 C19.5980821,3.32474275 19.6230251,3.08840776 19.668457,2.85653193 L19.668457,2.85653193 C20.0016244,1.22626644 21.4403018,-5.32907052e-15 23.1613698,-5.32907052e-15 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-WebPageBuilder-EmptyWidgets",
    transform: "translate(-67.000000, -776.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WPB-Widgets",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components",
    transform: "translate(24.000000, 640.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Scatter-Chart/40dp",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(12.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey",
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.000000, -11.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(3.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Dark",
    mask: "url(#mask-4)",
    fill: "#727272"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.000000, -6.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatterplotChart);
export default __webpack_public_path__ + "static/media/scatterplotChart.e8a1dee34599124ee40ae64c9d1dab63.svg";
export { ForwardRef as ReactComponent };